import * as React from "react";
import moment from "moment-jalaali";
import {Col, Form, Input, Row, Select, InputNumber} from "antd";
import {createRequest, fetchItemRequest, updateRequest} from "@actions/discountCodePolicy";
import {DiscountCodePolicy} from "@models/discountCodePolicy";
import TextEditor, {TextEditorRef} from "@components/custom/TextEditor";
import {FormattedMessage} from "react-intl";
import withFormWrapper from "@hocs/withFormWrapper";
import {SelectionMode} from '@models';
import DatePicker from "react-datepicker2";
import {toUTC, showDate} from "@utils";
import PackagesSelection from "@components/packages/Selection";
import PackageApproachsSelection from "@components/packages/approach/Selection";
import {Package} from '@models/package';
import {PaymentApproach} from "@models/paymentApproach";
import __i18n from "../../intl/__i18n";
import {DiscountCodePolicyCalculationType, DiscountCodePolicyCalculationTypeOptions,
  DiscountCodePolicyType, DiscountCodePolicyTypeOptions} from "../../models/discountCodePolicy";


const {Option} = Select

interface PropsFromState {
  loading: boolean;
  errors?: string;
  form: any;
  discountCodePolicy?: DiscountCodePolicy;
}

interface PropsFromDispatch {
  createRequest: typeof createRequest;
  updateRequest: typeof updateRequest;
  fetchItemRequest: typeof fetchItemRequest;
}

type DiscountCodePolicyFormAllProps = PropsFromState & PropsFromDispatch;

type DiscountCodePolicyFormStateShape = DiscountCodePolicy & {
  visible: boolean;
};


class DiscountCodePolicyForm extends React.Component<DiscountCodePolicyFormAllProps,
  DiscountCodePolicyFormStateShape> {
  constructor(props) {
    super(props);
    const {discountCodePolicy} = props;
    this.state = {
      visible: false,
      ...this.getStateFromProps(discountCodePolicy)
    };
  }
  
  private textEditorRef = React.createRef<TextEditorRef>();
  
  getStateFromProps = (discountCodePolicy: DiscountCodePolicy | null) => {
    const obj = discountCodePolicy || {};
    const {payment_approach, ...rest} = obj || {}
  
    return {
      package_payment_approach_id : payment_approach ? payment_approach.id : null,
      packagePaymentApproach: payment_approach,
      ...rest
    };
  };
  
  getValues = () => {
    let returnValues = null;
    
    this.props.form.setFieldsValue({
      "package_id": this.state.package && this.state.package.id,
      "package_payment_approach_id": this.state.packagePaymentApproach ? this.state.packagePaymentApproach.id : null,
    });
    
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        returnValues = {
          ...values,
          description: this.textEditorRef.current ? this.textEditorRef.current.value : "",
          "valid_from": new Date(toUTC(values.valid_from)).toISOString(),
          "valid_to": new Date(toUTC(values.valid_to)).toISOString(),
          "count": values.calculation_type === DiscountCodePolicyCalculationType.Percentage ? 1 : values.count
        }
      }
    });
    
    return {
      payload: returnValues,// !this.state.id ? returnValues : this.getPatchPayload(returnValues),
      id: this.state.id,
      // patch: this.state.id ? true : false
    };
  };
  
  onChangeApproach = (item: PaymentApproach) => {
    this.setState({
      "packagePaymentApproach": item
    });
  };
  
  onChangePackage = (item: Package) => {
    this.setState({
      "package": item
    });
  };
  
  render() {
    const {viewOnly=false} = this.props;
    const {getFieldDecorator, getFieldValue} = this.props.form;
    const reusableDiscount = getFieldValue("type") === DiscountCodePolicyType.ReusableDiscountCode;
    //TODO: check locale
    const showMaxValue = getFieldValue("calculation_type") === DiscountCodePolicyCalculationType.Percentage;
    
    return (
      <Form className={'discountCodePolicy-form'}>
        <Row>
          <Col span={8}>
            <Form.Item label={<FormattedMessage id="app.title" defaultMessage={`Title`} />}>
              {getFieldDecorator("title", {
                initialValue: this.state.title,
                rules: [{
                  required: true,
                  whitespace: true,
                  message: __i18n("{field} is required.", { field: __i18n("Title")})
                }]
              })(<Input disabled={viewOnly} />)}
            </Form.Item>
          </Col>
          
          <Col span={8}>
            <Form.Item label={__i18n("Type")}>
              {getFieldDecorator("type", {
                initialValue: this.state.type,
                rules: [{
                  required: true,
                  message: __i18n("{field} is required.", { field: __i18n("Type")})
                }]
              })(
                <Select disabled={viewOnly}>
                  {DiscountCodePolicyTypeOptions.map((opt, index) => (
                    <Option key={index} value={opt.value}>
                      {opt.label}
                    </Option>
                  ))}
                </Select>
              )}
            </Form.Item>
          </Col>
  
          {reusableDiscount && (
            <Col span={8}>
              <Form.Item label={__i18n("Unique Identifier")}>
                {getFieldDecorator("unique_identifier", {
                  initialValue: this.state.unique_identifier,
                  rules: [{
                    required: true,
                    message: __i18n("{field} is required.", { field: __i18n("Unique Identifier")})
                  }]
                })(<Input disabled={viewOnly}/>)}
              </Form.Item>
            </Col>
          )}
  
          <Col span={8}>
            <Form.Item label={__i18n("Calculation Type")}>
              {getFieldDecorator("calculation_type", {
                initialValue: this.state.calculation_type,
                rules: [{
                  required: true,
                  message: __i18n("{field} is required.", { field: __i18n("Calculation type")})
                }]
              })(
                <Select disabled={viewOnly}>
                  {DiscountCodePolicyCalculationTypeOptions.map((opt, index) => (
                    <Option key={index} value={opt.value}>
                      {opt.label}
                    </Option>
                  ))}
                </Select>
              )}
            </Form.Item>
          </Col>
          
          {showMaxValue && (
            <Col span={8}>
              <Form.Item label={__i18n("Max value")}>
                {getFieldDecorator("max_value", {
                  initialValue: this.state.max_value,
                  rules: [{
                    required: true,
                    message: __i18n("{field} is required.", { field: __i18n("Max  value")})
                  }]
                })(<InputNumber disabled={viewOnly} min={0}/>)}
              </Form.Item>
            </Col>
          )}
          
          <Col span={8}>
            <Form.Item label={__i18n("Discount Amount")}>
              {getFieldDecorator("amount", {
                initialValue: this.state.amount,
                rules: [{
                  required: true,
                  message: __i18n("{field} is required.", { field: __i18n("Discount Amount")})
                }]
              })(<InputNumber disabled={viewOnly} min={1} max={100}/>)}
            </Form.Item>
          </Col>
          
          {!reusableDiscount && (
            <Col span={8}>
              <Form.Item label={__i18n("Count")}>
                {getFieldDecorator("count", {
                  initialValue: this.state.count,
                  rules: [{
                    required: true,
                    message: __i18n("{field} is required.", { field: __i18n("Count")})
                  }]
                })(<InputNumber disabled={viewOnly} min={1}/>)}
              </Form.Item>
            </Col>
          )}
          
          <Col span={8}>
            <Form.Item label={__i18n("Max Usage Count")}>
              {getFieldDecorator("max_usage_count", {
                initialValue: this.state.max_usage_count,
                rules: [{
                  required: true,
                  message: __i18n("{field} is required.", { field: __i18n("Max count")})
                }]
              })(<InputNumber disabled={viewOnly} min={1} max={99}/>)}
            </Form.Item>
          </Col>
          
          <Col span={8}>
            <Form.Item label={__i18n("Package")}>
              {getFieldDecorator("package_id", {
                rules: [{
                  required: true,
                  message: <FormattedMessage id="app.package_is_required" defaultMessage={`Package is required!`}/>
                }]
              })}
              <PackagesSelection
                mode={SelectionMode.DEFAULT}
                disabled={viewOnly}
                onChange={this.onChangePackage}
                initialValue={this.state.package || null}
              />
            </Form.Item>
          </Col>
          
          
          <Col span={8}>
            <Form.Item label={__i18n("Package Payment Approach")}>
              {getFieldDecorator("package_payment_approach_id", {
                rules: [{
                  required: true
                }]
              })(
                <PackageApproachsSelection
                  mode={SelectionMode.DEFAULT}
                  packageId={this.state.package ? this.state.package.id : null}
                  disabled={(!viewOnly && this.state.package) ? false : true}
                  onChange={this.onChangeApproach}
                  initialValue={this.state.packagePaymentApproach}/>
              )}
            </Form.Item>
          </Col>
  
          <Col span={8}>
            <Form.Item label={__i18n("Valid from")}>
              {getFieldDecorator("valid_from", {
                initialValue: this.state.valid_from ? moment(this.state.valid_from) : "",
                rules: [{
                  required: true,
                  message: __i18n("{field} is required.", { field: __i18n("Valid from")})
                }]
              })(
                <DatePicker
                  disabled={viewOnly}
                  isGregorian={false}
                  timePicker={false}
                />
              )}
            </Form.Item>
          </Col>
  
          <Col span={8}>
            <Form.Item label={__i18n("Valid to")}>
              {getFieldDecorator("valid_to", {
                initialValue: this.state.valid_to ? moment(this.state.valid_to) : "",
                rules: [{
                  required: true,
                  message: __i18n("{field} is required.", { field: __i18n("Valid to")})
                }]
              })(
                <DatePicker
                  disabled={viewOnly}
                  isGregorian={false}
                  timePicker={false}
                />
              )}
            </Form.Item>
          </Col>
  
          <Col span={24}>
            <Form.Item label={__i18n("Description")}>
              {getFieldDecorator("description")(
                <TextEditor disabled={viewOnly} ref={this.textEditorRef} text={this.state.description} />
              )}
            </Form.Item>
          </Col>
        </Row>
      
      </Form>
    );
  }
}

export default withFormWrapper(
  Form.create({name: "discountCodePolicy-form"})(DiscountCodePolicyForm)
);
